export default "__VITE_ASSET__CRqRT9Eq__"